module.exports = __webpack_public_path__ + "static/media/icon-profile.47dba72f.png";